/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InformationExtractionLanguageEnum } from './InformationExtractionLanguageEnum';
import {
  InformationExtractionLanguageEnumFromJSON,
  InformationExtractionLanguageEnumFromJSONTyped,
  InformationExtractionLanguageEnumToJSON,
} from './InformationExtractionLanguageEnum';
import type { InformationExtractionSchemaDetail } from './InformationExtractionSchemaDetail';
import {
  InformationExtractionSchemaDetailFromJSON,
  InformationExtractionSchemaDetailFromJSONTyped,
  InformationExtractionSchemaDetailToJSON,
} from './InformationExtractionSchemaDetail';
import type { DatasetDocument } from './DatasetDocument';
import { DatasetDocumentFromJSON, DatasetDocumentFromJSONTyped, DatasetDocumentToJSON } from './DatasetDocument';
import type { TaskTypeEnum } from './TaskTypeEnum';
import { TaskTypeEnumFromJSON, TaskTypeEnumFromJSONTyped, TaskTypeEnumToJSON } from './TaskTypeEnum';

/**
 *
 * @export
 * @interface DatasetPolymorphicInformationExtractionDataset
 */
export interface DatasetPolymorphicInformationExtractionDataset {
  /**
   *
   * @type {TaskTypeEnum}
   * @memberof DatasetPolymorphicInformationExtractionDataset
   */
  taskType: TaskTypeEnum;
  /**
   *
   * @type {number}
   * @memberof DatasetPolymorphicInformationExtractionDataset
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof DatasetPolymorphicInformationExtractionDataset
   */
  datasetPath: string;
  /**
   *
   * @type {boolean}
   * @memberof DatasetPolymorphicInformationExtractionDataset
   */
  readonly hasPredictions: boolean;
  /**
   *
   * @type {Array<DatasetDocument>}
   * @memberof DatasetPolymorphicInformationExtractionDataset
   */
  readonly documents: Array<DatasetDocument>;
  /**
   *
   * @type {InformationExtractionSchemaDetail}
   * @memberof DatasetPolymorphicInformationExtractionDataset
   */
  schema: InformationExtractionSchemaDetail;
  /**
   *
   * @type {InformationExtractionLanguageEnum}
   * @memberof DatasetPolymorphicInformationExtractionDataset
   */
  language: InformationExtractionLanguageEnum;
}

/**
 * Check if a given object implements the DatasetPolymorphicInformationExtractionDataset interface.
 */
export function instanceOfDatasetPolymorphicInformationExtractionDataset(
  value: object,
): value is DatasetPolymorphicInformationExtractionDataset {
  if (!('taskType' in value) || value['taskType'] === undefined) return false;
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('datasetPath' in value) || value['datasetPath'] === undefined) return false;
  if (!('hasPredictions' in value) || value['hasPredictions'] === undefined) return false;
  if (!('documents' in value) || value['documents'] === undefined) return false;
  if (!('schema' in value) || value['schema'] === undefined) return false;
  if (!('language' in value) || value['language'] === undefined) return false;
  return true;
}

export function DatasetPolymorphicInformationExtractionDatasetFromJSON(
  json: any,
): DatasetPolymorphicInformationExtractionDataset {
  return DatasetPolymorphicInformationExtractionDatasetFromJSONTyped(json, false);
}

export function DatasetPolymorphicInformationExtractionDatasetFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): DatasetPolymorphicInformationExtractionDataset {
  if (json == null) {
    return json;
  }
  return {
    taskType: TaskTypeEnumFromJSON(json['task_type']),
    id: json['id'],
    datasetPath: json['dataset_path'],
    hasPredictions: json['has_predictions'],
    documents: (json['documents'] as Array<any>).map(DatasetDocumentFromJSON),
    schema: InformationExtractionSchemaDetailFromJSON(json['schema']),
    language: InformationExtractionLanguageEnumFromJSON(json['language']),
  };
}

export function DatasetPolymorphicInformationExtractionDatasetToJSON(
  value?: Omit<DatasetPolymorphicInformationExtractionDataset, 'id' | 'hasPredictions' | 'documents'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    task_type: TaskTypeEnumToJSON(value['taskType']),
    dataset_path: value['datasetPath'],
    schema: InformationExtractionSchemaDetailToJSON(value['schema']),
    language: InformationExtractionLanguageEnumToJSON(value['language']),
  };
}
